define.alias("shared/components/shared/post/secondary/high-performer/wrapper", "settings/components/shared/post/secondary/high-performer/wrapper");